import { makeStyles } from 'tss-react/mui';
import { colors, spacing, fontWeights } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    wrapper: {
        position: 'relative',
        width: '100%',
        fontFamily: 'inherit',
    },
    inputWrapper: {
        position: 'relative',
    },
    clearButton: Object.assign(Object.assign({ position: 'absolute', right: 12, transform: 'translateY(-50%)', cursor: 'pointer', color: colors.grey.grey5 }, theme.typography.small_button), { fontWeight: fontWeights.regular, borderRadius: '50%', '&:hover': {
            background: colors.grey.grey1,
        } }),
    loader: {
        marginRight: '12px',
        marginLeft: '12px',
    },
    option: Object.assign(Object.assign({ cursor: 'pointer' }, theme.typography.small_regular), { fontWeight: fontWeights.regular, borderBottom: `1px solid ${colors.grey.grey2}`, '&:last-child': {
            borderBottom: 'none',
        }, padding: `0px ${spacing.xs}`, '&:hover': {
            backgroundColor: colors.grey.grey1,
        }, '&.Mui-focused': {
            backgroundColor: colors.grey.grey1,
        } }),
    optionButton: { color: colors.supplementary.black },
    list: {
        position: 'absolute',
        zIndex: 10,
        backgroundColor: colors.supplementary.white,
        width: '100%',
        border: `1px solid ${colors.supplementary.black}`,
        borderTop: 'none',
        maxHeight: 200,
        overflowY: 'auto',
        borderRadius: `0 0 ${spacing.xxs} ${spacing.xxs}`,
        boxShadow: 'rgb(0, 139, 233) 0px 0px 8px, rgba(0, 0, 0, 0.32) 0px 4px 8px',
        padding: `${spacing.xs} 0`,
    },
    itemHover: {
        background: colors.grey.grey1,
    },
    errorMessage: Object.assign(Object.assign({ color: theme.statusColors.error.base }, theme.typography.small_bold), { letterSpacing: '0px', padding: 0, fontWeight: fontWeights.regular, marginTop: `${spacing.xs}` }),
    textField: Object.assign(Object.assign({}, theme.typography.small_regular), { height: 'auto', fontWeight: fontWeights.regular }),
    textFieldLoading: {
        background: colors.grey.grey2,
    },
}));
export default useStyles;
